<template>
	<div class="menuList" @click="routerTo">
		<div class="icon"><slot name="icon"></slot></div>
		{{ label }}
	</div>
</template>


<script>
	export default {
		name: 'menuList',
		props: {
			label: {
				type: String,
				default: ''
			},
			linkUrl: {
				type: String,
				default: '/'
			},
		},
		methods: {
			routerTo() {
				if (this.linkUrl && this.linkUrl !== '/') {
				    this.$router.push(this.linkUrl);
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.menuList {
		font-family: PingFang SC;
		width: 25%;
		color: #666666;
		font-size: .28rem;
		text-align: center;
		margin-bottom: .25rem;
		text-transform: capitalize;
		.icon {
			width: .64rem;
			height: .64rem;
			margin: 0 auto;
			margin-bottom: .04rem;
			img {
				display: block;
				width: 100%;
			}
		}
	}
</style>

